// extracted by mini-css-extract-plugin
export default {"FormCardSubtitle":"FormCardSubtitle_FormCardSubtitle__oPSHX"};